import AccountSettings from '@/components/accountSettingsPage/AccountSettings';

function AccountSettingsPage() {
  return <AccountSettings />;
}

export default AccountSettingsPage;
